module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-9.80205a87.mp3";